import React from 'react';
import { company, founders } from '../data/company';
import { Card, CardTag } from './Card';
import { Section } from './Section';
export function TeamSection() {
  return <Section id="quien" number="02" title="Quién está detrás del negocio" subtitle="Massive Faith LLC es propiedad de dos socios en partes iguales, personas reales e identificables que dirigen la empresa y responden por ella. No trabajamos con marcas anónimas ni intermediarios." data-id="element-171" data-mp="3l2y22gsjgwdk">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-172" data-mp="365x969ym2vdi">
        {founders.map(f => <Card key={f.name} data-id="element-173" data-mp="323shhgrq48ti">
            <div className="flex flex-wrap items-start gap-[22px]" data-id="element-174" data-mp="3253lnhp2zil5">
              <div className="grid h-[72px] w-[72px] shrink-0 place-items-center rounded-full bg-accent text-2xl font-extrabold text-white" aria-hidden="true" data-id="element-175" data-mp="2x58wbikyf127">
                {f.initials}
              </div>
              <div className="min-w-[220px] flex-1" data-id="element-176" data-mp="vedw8ejpsfpo">
                <h3 className="mb-2 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-177" data-mp="1u5z7rpmx9srg">{f.name}</h3>
                <CardTag data-id="element-178" data-mp="1z63jz3gss1bv">{f.role}</CardTag>
                <p className="leading-relaxed text-body" data-id="element-179" data-mp="1z6vcu6j0fkyg">{f.bio}</p>
              </div>
            </div>
          </Card>)}
      </div>
      <p className="mt-5 text-body" data-id="element-180" data-mp="1q4m2bgnqrrl2">
        <strong className="font-bold text-fg" data-id="element-181" data-mp="1q5ot7ol2du0z">Contacto directo:</strong>{' '}
        <a href={`mailto:${company.email}`} className="text-accent-soft hover:underline" data-id="element-182" data-mp="2du81i44466t2">
          {company.email}
        </a>{' '}
        ·{' '}
        <a href={company.phoneHref} className="text-accent-soft hover:underline" data-id="element-183" data-mp="2hy61si56dnnp">
          {company.phone}
        </a>
      </p>
    </Section>;
}